/** Which vanilla sound event a redstone block fx plays (the `fx` kinds of sim.ts / actions.ts). */
import { BLOCKS, IRON_DOOR_ID, IRON_TRAPDOOR_ID, IRON_TOGGLE } from '../../blocks';
import { K, RS_KIND, RS_VAR } from './defs';

/** Vanilla NoteBlockInstrument order used by power.ts `noteData`. */
export const NOTE_INSTRUMENTS = ['harp', 'bass', 'snare', 'hat', 'basedrum', 'bell', 'flute', 'chime', 'guitar', 'xylophone', 'iron_xylophone', 'cow_bell', 'didgeridoo', 'bit', 'banjo', 'pling'] as const;

export interface RedstoneSound { id: string; pitch?: number }

/** `id` is the block now at the fx position; null = not a redstone sound (the caller's default applies). */
export function redstoneSound(kind: string, id: number, d: number): RedstoneSound | null {
  switch (kind) {
    case 'note': return { id: `block.note_block.${NOTE_INSTRUMENTS[(d >> 8) & 15]}`, pitch: 2 ** (((d & 255) - 12) / 12) };
    case 'piston': return { id: d ? 'block.piston.extend' : 'block.piston.contract' };
    case 'door': {
      const name = BLOCKS[id]?.name ?? '';
      if (id === IRON_DOOR_ID || /^Iron Door/.test(name)) return { id: d ? 'block.iron_door.open' : 'block.iron_door.close' };
      if (id === IRON_TRAPDOOR_ID || /^Iron Trapdoor/.test(name) || (IRON_TOGGLE[id] !== undefined && /Trapdoor/.test(name))) return { id: d ? 'block.iron_trapdoor.open' : 'block.iron_trapdoor.close' };
      return null;
    }
    case 'click': {
      const on = d ? 'on' : 'off';
      switch (RS_KIND[id]) {
        case K.LEVER: return { id: 'block.lever.click', pitch: d ? 0.6 : 0.5 };
        case K.BUTTON: return { id: `block.${RS_VAR[id] === 1 ? 'wooden' : 'stone'}_button.click_${on}` };
        case K.PLATE: return { id: `block.${['stone', 'wooden', 'metal', 'metal'][RS_VAR[id]]}_pressure_plate.click_${on}` };
        case K.TRIPWIRE: case K.HOOK: return { id: `block.tripwire.click_${on}` };
        case K.COMPARATOR: return { id: 'block.comparator.click', pitch: d ? 0.55 : 0.5 };
        default: return { id: 'block.lever.click', pitch: d ? 0.6 : 0.5 };
      }
    }
    default: return null;
  }
}
